//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		props: ["xsongs"],
		data() {
			return {
				list:[],
				xlsx:false,
				getpage:null,
				lbwx:false,
				fh:false,
			}
		},
		mounted() {
			//$watch可以解决异步问题
			this.$watch("xsongs",function(){
				if(this.xsongs.length != 0){
					this.list = this.list.concat(this.xsongs);
					var xthis= this;
					if(xthis.xsongs.length < 30){
						xthis.xlsx = false;
						xthis.lbwx = true;
					}
					document.querySelector("body").onscroll = function(e) {
						var xhigth = document.documentElement.clientHeight;
						var zhight = document.body.clientHeight;
						var top = document.querySelector("body").scrollTop;
						//标题事件
						var title = document.querySelector("body .title");
						if(title){
							if(top > 250){
								title.style.background = '#fc378c';
							}else{
								title.style.background = '-webkit-linear-gradient(top,rgba(0,0,0,.6),transparent)';
							}					
						}
						//数据加载
						if(xhigth + top == zhight){
							if(xthis.xsongs.length < 30){
								xthis.xlsx = false;
								xthis.lbwx = true;
							}else{
								xthis.xlsx = true;								
							}
							xthis.getpage = xthis.getPage+1;
							xthis.$store.dispatch('setPage',xthis.getpage);
							xthis.$store.dispatch("rangeDetails");
						}
						if(top>xhigth){
							xthis.fh = true
						}else{
							xthis.fh = false
						}
					}
				}else{
					this.xlsx = false;
					this.lbwx = true;
				}
			})
			//音乐播放
			this.$watch("newMusic",function(){
				var arr = [this.newMusic];
				this.$store.dispatch('setImg', [this.newMusic.imgUrl,true]);
           		this.$store.dispatch('setSongs',arr);
			})
		},
		methods:{
			onfh(){
				var i = 0;
				var timer =setInterval(function(){
					i+=10;
					document.body.scrollTop = document.body.scrollTop - i;
					if(document.body.scrollTop <=0){
						clearInterval(timer);
					}
				},5)
			},
			music(e){
				document.querySelector("#app .kgmusic").style.display = 'block'
				//获取嘻哈值
				var xhz = this.list[e].hash
				//获取歌曲列表
				this.$store.dispatch('setMusic',xhz);
			},
			xiazai(){
				this.$watch("newMusic",function(){
					window.location.href = this.newMusic.url
				})
			}
		},
		computed:{
			getPage(){
				if(this.$store.getters.giePage) {
					return this.$store.getters.giePage
				}
			},
			newMusic(){
				if(this.$store.getters.newMusic) {
					var img = this.$store.getters.newMusic;
					img.imgUrl =  img.imgUrl.replace(/{size}/g,'400');
					return img;
				}
			},
		}
	};



// WEBPACK FOOTER //
// ./src/components/rangeDetails/list.vue